import MoreActionsButton from './MoreActionsButton';
import MoreActionsButtonContainer from './MoreActionsButton.container';
export default MoreActionsButtonContainer(MoreActionsButton);
